<template>
  <IconSvgBase :class="$style.icon" :view-width="32" :view-height="32">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.6667 10.666C14.6667 9.93002 15.2641 9.33268 16.0001 9.33268C16.7361 9.33268 17.3334 9.93002 17.3334 10.666V17.3327C17.3334 18.0687 16.7361 18.666 16.0001 18.666C15.2641 18.666 14.6667 18.0687 14.6667 17.3327V10.666ZM14.6667 21.3327C14.6667 20.5967 15.2641 19.9993 16.0001 19.9993C16.7361 19.9993 17.3334 20.5967 17.3334 21.3327C17.3334 22.0687 16.7361 22.666 16.0001 22.666C15.2641 22.666 14.6667 22.0687 14.6667 21.3327ZM16.0001 26.666C10.1187 26.666 5.33341 21.8807 5.33341 15.9993C5.33341 10.118 10.1187 5.33268 16.0001 5.33268C21.8814 5.33268 26.6667 10.118 26.6667 15.9993C26.6667 21.8807 21.8814 26.666 16.0001 26.666ZM16.0001 2.66602C8.63608 2.66602 2.66675 8.63535 2.66675 15.9993C2.66675 23.3633 8.63608 29.3327 16.0001 29.3327C23.3641 29.3327 29.3334 23.3633 29.3334 15.9993C29.3334 8.63535 23.3641 2.66602 16.0001 2.66602Z"
      :class="$style.icon__path"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconExclamationCircle',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__path {
    fill: currentcolor;
  }
}
</style>
